<template>
	<rmp-text font="secondary" type="body-medium-bold" :color="colors.grey.darken1" class="mb-4">
		<slot></slot>
	</rmp-text>
</template>

<script setup lang="ts">
import RmpText from "@rmp/core/components/typography/RmpText.vue";
import { useColors } from "@rmp/core/composables/useColors";

const { colors } = useColors();
</script>

<style scoped>

</style>
